import { Create, Edit, List, Show, BulkCreate, Card, Issue, Remove, ItemUsers, Barcode, BulkBarcode, MyItem, Requisition, StoreTransfer, Print } from "../Components/index.js";

export default [
    {
        path: "/property/item",
        component: List,
        name: "property",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/item/create",
        component: Create,
        name: "property.entry",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/property/item/:id/show",
        component: Show,
        name: "property.show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/item/:id/barcode",
        component: Barcode,
        name: "property.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/item/barcode",
        component: BulkBarcode,
        name: "property.bulk.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/item/:id/edit",
        component: Edit,
        name: "property.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/item/:id/card",
        component: Card,
        name: "property.card",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/property/item-issue",
        component: Issue,
        name: "property.issue",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/item-remove",
        component: Remove,
        name: "property.remove",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/my-item",
        component: MyItem,
        name: "property.my.issue",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/my-requisition",
        component: Requisition,
        name: "property.my.requisition",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/item/users",
        component: ItemUsers,
        name: "property.users",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property/item/store-transfer",
        component: StoreTransfer,
        name: "property.store.tranfer",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/property/item-user/print-voucher/:code",
        component: Print,
        name: "property-user-voucher-print",
        meta: {
            requiresAuth: true,
        },
    },
];
